<template>
  <div class="app">
    <AppHeader/>
    <div class="app-body">
      <Sidebar :navItems="nav"/>
      <main class="main">
 <!--       <breadcrumb :list="list"/> -->
 
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside/>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
import nav from '../_nav'
// import { Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter, Breadcrumb } from '../components/'
import { Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter } from '../components/'
export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter
  //  Breadcrumb
  },
  created: function () {
    var current_role = localStorage.getItem('role')
    var menu = 0
    if ('menu' in  localStorage) {
      menu = localStorage.getItem('menu')
    }
    if ( current_role == 'super_admin') {
      this.nav = nav.items 
    }else if (current_role == 'analyst') {
      if (menu==1) {
        this.nav = nav.items_analyst_ser
      } else {
        this.nav = nav.items_analyst
      }     
    }else if (current_role == 'super_analyst') {
      if (menu==1) {
        this.nav = nav.items_super_analyst_ser
      } else {
        this.nav = nav.items_super_analyst
      }
    }  
    else if (current_role == 'marketing_accountant') {
        this.nav = nav.items_marketing_accountant    
    }else if (current_role == 'trucking_company_admin') {
      this.nav = nav.items_trucking_company_admin
    }else if (current_role == 'driver') {
      this.nav = nav.items_drivers
    }else if (current_role == 'trucking_company_admin_light') {
      this.nav = nav.items_trucking_company_admin_light
    }else if (current_role == 'operations_manager') {
      this.nav = nav.items_operations_manager_admin
    } else if (current_role == 'trucking_operational_manager') {
      this.nav = nav.items_trucking_operational_manager
    }
  },
  data () {
    return {
      nav: [{
      title: true,
      name: 'Area Admin',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    }]
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Full.vue